module.exports = __webpack_public_path__ + "static/subset-UniNeueBook-Italic-bd3a915529afe50c77ddc7163d5afd8a.woff";